import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=742a037c"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductGalleryCarousel: require('/opt/build/repo/components/product/GalleryCarousel.vue').default,ProductDetails: require('/opt/build/repo/components/product/Details.vue').default,ProductPrice: require('/opt/build/repo/components/product/Price.vue').default,EshopCartForm: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartForm.vue').default,ProductAttributes: require('/opt/build/repo/components/product/Attributes.vue').default,ProductCountry: require('/opt/build/repo/components/product/Country.vue').default})
